import { useContext, useState } from "react";
import "./styles.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/axiosConfig";
import { Context } from "../../../hooks/useAuthContext";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import FullScreenLoader from "../../../components/FullScreenLoader/FullScreenLoader";
import { validarSenhaSegura } from "../../../utils/ValidatePassword";

function NovaSenha() {
  const { exibirLogs } = useContext(Context);
  const { code } = useParams();
  const navigate = useNavigate();

  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [loading, setLoading] = useState(false);
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmaSenha, setConfirmaSenha] = useState("");

  const { valido, htmlFeedback } = validarSenhaSegura(novaSenha);

  const toggleMostrarSenha = () => {
    setMostrarSenha((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!valido) {
      Swal.fire({
        title: "Senha fraca!",
        html: htmlFeedback,
        icon: "error",
      });

      return;
    }

    if (novaSenha !== confirmaSenha) {
      return Swal.fire({
        icon: "warning",
        title: "Senhas não coincidem",
        text: "Verifique se os campos estão iguais.",
      });
    }

    try {
      setLoading(true);
      await api.put("/recovery/alterar-senha/", {
        code,
        password: novaSenha,
      });

      Swal.fire({
        icon: "success",
        title: "Senha atualizada com sucesso!",
        confirmButtonText: "Ir para o login",
      }).then(() => {
        navigate("/login");
      });
    } catch (error) {
      exibirLogs && console.error("Erro ao atualizar senha:", error);

      if (error.status == 405) {
        Swal.fire({
          title: error.response.data.error,
          text: "Contate um administrador para recuperar a senha",
          icon: "error",
        });

        return;
      }
      toast.error(error.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wrapper">
      {loading && <FullScreenLoader />}
      <div className="recuperarSenha">
        <div className="logoRecuperarSenha">
          <img src="https://i.imgur.com/bMhAXFy.png" alt="Logo link do bem" />
        </div>

        <div className="formRecuperacao">
          <span className="titleTextRecuperar">Recuperar senha</span>

          <form className="form" style={{ marginTop: 20 }}>
            <div className="formGroup">
              <label htmlFor="novaSenha">Crie uma nova senha</label>
              <input
                id="novaSenha"
                className="inputForm"
                type={mostrarSenha ? "text" : "password"}
                placeholder="Digite aqui"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
              />
            </div>

            <div className="formGroup" style={{ marginTop: 15 }}>
              <label htmlFor="confirmaSenha">Confirme sua senha</label>
              <input
                id="confirmaSenha"
                className="inputForm"
                type={mostrarSenha ? "text" : "password"}
                placeholder="Digite aqui"
                value={confirmaSenha}
                onChange={(e) => setConfirmaSenha(e.target.value)}
              />
            </div>

            <div
              className="mostrarSenha"
              onClick={toggleMostrarSenha}
              style={{ cursor: "pointer" }}
            >
              {mostrarSenha ? <FaEyeSlash /> : <FaEye />}
              <span> {mostrarSenha ? "Esconder senha" : "Mostrar senha"}</span>
            </div>

            <button
              type="submit"
              style={{ marginTop: 15 }}
              onClick={(e) => handleSubmit(e)}
            >
              Salvar e atualizar
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default NovaSenha;
